import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { PermissionHandlerService } from './permission-handler.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateFieldsService {
  permissionHideFieldsForInvester: any[] = [];

  constructor(
    private dataService: DataService,
    private permissionService: PermissionHandlerService,
  ) { }

  templates: any = []
  selectedTemplete : any

  async fetchTemplateFields(data: any) {

    const selectedTemplate = this.templates.find((obj:any) => {return obj.type === data.type._id && obj.ou === data.ous})?.template;
   
    console.log("===>Templates", selectedTemplate);

    if (selectedTemplate) {
      console.log("Selected Template:", selectedTemplate);
      this.selectedTemplete = selectedTemplate;
      return this.filterDataByTemplate(data,this.selectedTemplete.fields)
     
    }


    let res = await this.dataService.postData('data-template/get/data', {
      active: true,
      type: data.type._id
      // ou: data._id
    });
    if (res.error) {
      // return;
    }
    let templates = res.data.data

    
    let temp: any = []
    templates.forEach((e: any) => {
      if (e.ou != null) {
        let test = e?.ou.filter((item: any) => item._id == data.ous)
        if (test.length > 0) {
          temp.push(e)
        }
      }
    });
    
    console.log("===>Templates1",templates, temp)
    

    if (temp.length <= 0) {
      temp = templates.find((obj: any) => obj.ou === null)
    } else {
      temp = temp[0]
    }

    console.log("===>Temp(((((",temp);

    // console.log('id', this.myForm.value.ou._id, '===>this.templates', temp, "new=>", this.templates);
    temp?.fields.sort((a: any, b: any) => {
      if (a.priority && b.priority) {
        return a.priority - b.priority;
      } else {
        return 0;
      }
    })
    

    console.log("===>Templates2", temp);


    this.templates.push({type: data.type._id, ou: data.ous , template: temp})

    this.selectedTemplete = temp;


    return this.filterDataByTemplate(data,this.selectedTemplete.fields)
   
  }


  async fetchTemplateFieldsbyArray(data: any) {
    const selectedTemplate = this.templates.find((obj:any) => {return obj.type === data.type._id && obj.ou === data.ous})?.template;
    console.log("===>Templates", selectedTemplate);
    if (selectedTemplate) {
      console.log("Selected Template:", selectedTemplate);
      this.selectedTemplete = selectedTemplate;
      return this.filterDataByTemplateArray(data,this.selectedTemplete.fields)
     
    }


    let res = await this.dataService.postData('data-template/get/data', {
      active: true,
      type: data.type._id
      // ou: data._id
    });
    if (res.error) {
      // return;
    }
    let templates = res.data.data

    
    let temp: any = []
    templates.forEach((e: any) => {
      if (e.ou != null) {
        let test = e?.ou.filter((item: any) => item._id == data.ous)
        if (test.length > 0) {
          temp.push(e)
        }
      }
    });
    
    console.log("===>Templates1",templates, temp)
    

    if (temp.length <= 0) {
      temp = templates.find((obj: any) => obj.ou === null)
    } else {
      temp = temp[0]
    }

    console.log("===>Temp(((((",temp);

    // console.log('id', this.myForm.value.ou._id, '===>this.templates', temp, "new=>", this.templates);
    temp?.fields.sort((a: any, b: any) => {
      if (a.priority && b.priority) {
        return a.priority - b.priority;
      } else {
        return 0;
      }
    })
    

    console.log("===>Templates2", temp);


    this.templates.push({type: data.type._id, ou: data.ous , template: temp})

    this.selectedTemplete = temp;


    return this.filterDataByTemplateArray(data,this.selectedTemplete.fields)
   
  }

  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");

  async filterDataByTemplate(data :any, template : any) {
   
    let fields : any = []

    if (!this.permissionService.isLoggedIn) {
      //await this.permissionService.init();
      this.permissionHideFieldsForInvester = this.permissionService.payload.templateHide.fields;

      
    }

    data.fields.map((dataObj : any) =>{
       let flag =  template.some((templateField:any)=> dataObj.field._id === templateField._id);
       if(flag) {


        // fields.push(dataObj)

        if (!this.permissionHideFieldsForInvester.includes(dataObj.field._id)) fields.push(dataObj)

       }
    }
   );

      // Step 2: Include fields from the template that are not present in data
    template.forEach((templateField : any) => {
      let flag = data.fields.some((dataObj:any) => dataObj.field._id == templateField._id);
      if (!flag) {
        fields.push({...templateField, data:"لا يوجد" , label : { name : templateField.name , type : templateField.type._id} , isChecked : false, isNew : true});
      }
    });

    

   return fields
 }


//  filterDataByTemplate(data: any, template: any): any[] {
//   console.log("----K2", data, template);

//   const fields: any[] = [];

//   template.forEach((templateField: any) => {
//     const dataObj = data.fields.find((dataField: any) => dataField.field._id === templateField._id);

//     if (dataObj) {
//       fields.push(dataObj);
//     } else {
//       // Field not present in data, add a corresponding entry with null data
//       fields.push({
//         field: {
//           _id: templateField._id,
//           // Add other properties as needed
//         },
//         data: null
//       });
//     }
//   });

//   return fields;
// }


 filterDataByTemplateArray(data :any, template : any) {
  console.log("----K2", data,template);
  
  let fields : any = []

 
  data.fields.map((dataObj : any) =>{
     let flag =  template.some((templateField:any)=> dataObj.field[0]._id === templateField._id);
     flag ?  fields.push(dataObj) : null
     }
 );

 return fields
}



}
